import Thumbnails from './ThumbnailsTemplate';

export default Thumbnails;
